/**
 * SMS GraphQL Queries
 * Consolidated queries for SMS operations including inbound SMS count
 */

export const SMS_QUERIES = {
  // SMS count for admin users (PA, CA, EA)
  GET_SMS_COUNT_ADMIN: `
    query smsCountForEnrollerAdmin {
      api_sms_aggregate(where: {inbound_sms_read_by: {_is_null: true}, key: {_eq: "PEP"}, sms_type: {_eq: "INBOUND"}}) {
        aggregate {
          count
        }
      }
    }
  `,

  // SMS count for regular users
  GET_SMS_COUNT_USER: `
    query smsCountForEnrollerUsers($loggedInUserID: bigint!) {
      api_sms_aggregate(where: {inbound_sms_read_by: {_is_null: true}, key: {_eq: "PEP"}, sms_type: {_eq: "INBOUND"}, inbound_sms: {work_force_id: {_eq: $loggedInUserID}}}) {
        aggregate {
          count
        }
      }
    }
  `,
} as const;

export default SMS_QUERIES;